import { useCallback, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import {
  PATH_SETTINGS_PAYMENT_METHODS,
  PATH_SETTINGS_PAYMENT_METHODS_ADD_PAYOUT_METHOD,
  PATH_SETTINGS_PAYMENT_METHODS_MANAGE_PAYOUT_METHOD
} from "..";
import { Layout } from "../../../../../shared/components/Layout";
import { FlowAddPayoutMethod } from "../../../components/payout/FlowAddPayoutMethod";

export const RouteAddPayoutMethod: React.FC = () => {
  const history = useHistory();

  const location = useLocation<{ backPath?: string }>();

  const [backPath] = useState(
    location.state?.backPath || PATH_SETTINGS_PAYMENT_METHODS
  );

  const onBack = useCallback(() => {
    history.push(backPath);
  }, [backPath, history]);

  return (
    <Layout title="Add payout method" onClose={onBack} showFooterAdditionalInfo>
      <FlowAddPayoutMethod
        basePath={PATH_SETTINGS_PAYMENT_METHODS_ADD_PAYOUT_METHOD}
        onBack={onBack}
        onNext={onBack}
        onError={error => {
          history.push(PATH_SETTINGS_PAYMENT_METHODS_MANAGE_PAYOUT_METHOD, {
            error
          });
        }}
      />
    </Layout>
  );
};
